import React from "react";
import logo from "../../assets/images/logos/stmarys-logo.png"
import logo2 from "../../assets/images/logos/stmarys_logo.png"



function NoPage() {
    
    return <>
       <div className="nopage">
         <img className="logo404" src={logo2} alt="" />
         <h1>Page not found...</h1>
       </div>
    </>
}

export default NoPage;